import { ATTORNEY_COMPANY_TYPE } from 'app/pages/loanApplication/tabs/loanClosingCDS/shared/ClosingCompany/ClosingCompany.constants';

import { AttendantCompanyTypeEnum } from 'constants/loanApplication';
import { getCleanPhoneNumber } from 'utils/data';

import { getAttorneyFieldIds, getCompanyFieldIds } from '../EditDrawer.companyConfig';

export const COMPANY_CONFIGS = [
  {
    prefix: 'title',
    filterType: AttendantCompanyTypeEnum.TITLE,
    categoryType: AttendantCompanyTypeEnum.TITLE,
    getFieldIds: getCompanyFieldIds,
    hasChangeLocation: true,
  },
  {
    prefix: 'escrow',
    filterType: AttendantCompanyTypeEnum.ESCROW,
    categoryType: AttendantCompanyTypeEnum.ESCROW,
    getFieldIds: getCompanyFieldIds,
    hasChangeLocation: true,
  },
  {
    prefix: 'sellerAttorney',
    filterType: ATTORNEY_COMPANY_TYPE,
    categoryType: AttendantCompanyTypeEnum.SELLER_ATTORNEY,
    getFieldIds: getAttorneyFieldIds,
    getExtraLocationFields: (fieldId, location) => ({
      [fieldId.phone]: getCleanPhoneNumber(location.phone) || '',
      [fieldId.email]: location.email || '',
    }),
  },
  {
    prefix: 'buyerAttorney',
    filterType: ATTORNEY_COMPANY_TYPE,
    categoryType: AttendantCompanyTypeEnum.BUYER_ATTORNEY,
    getFieldIds: getAttorneyFieldIds,
    getExtraLocationFields: (fieldId, location) => ({
      [fieldId.phone]: getCleanPhoneNumber(location.phone) || '',
      [fieldId.email]: location.email || '',
    }),
  },
];
